// src/features/tidsregistering/hooks/useClosingPeriods.js
import { useState, useCallback } from 'react';
import { closingPeriodsAPI } from '../services/closingPeriods';
import { useApi } from '../../../hooks/api/useApi';

export function useClosingPeriods() {
  const [closingPeriod, setClosingPeriod] = useState(null);
  const [closingPeriods, setClosingPeriods] = useState([]);
  const [staffClosingPeriods, setStaffClosingPeriods] = useState([]);
  const { loading, error, execute, clearError } = useApi();

  const fetchClosingPeriod = useCallback(async (closingPeriodId) => {
    const result = await execute(() => closingPeriodsAPI.getClosingPeriod(closingPeriodId));
    if (result.success) setClosingPeriod(result.data ?? null);
    return result;
  }, [execute]);

  const fetchForDepartment = useCallback(async () => {
    const result = await execute(() => closingPeriodsAPI.listForDepartment());
    if (result.success) setClosingPeriods(result.data?.closing_periods ?? []);
    return result;
  }, [execute]);

  const fetchStaffClosingPeriods = useCallback(async (closingPeriodId) => {
    const result = await execute(() => closingPeriodsAPI.listStaffClosingPeriods(closingPeriodId));
    if (result.success) setStaffClosingPeriods(result.data?.staff_closing_periods ?? []);
    return result;
  }, [execute]);

  const initiatePeriodClose = useCallback(async (data) => {
    const result = await execute(() => closingPeriodsAPI.initiatePeriodClose(data));
    if (result.success) setClosingPeriod(result.data ?? null);
    return result;
  }, [execute]);

  const calculatePeriod = useCallback(async (closingPeriodId) => {
    const result = await execute(() => closingPeriodsAPI.calculatePeriod(closingPeriodId));
    if (result.success) setClosingPeriod(result.data ?? null);
    return result;
  }, [execute]);

  const exportPeriod = useCallback(async (closingPeriodId) => {
    const result = await execute(() => closingPeriodsAPI.exportPeriod(closingPeriodId));
    if (result.success) setClosingPeriod(result.data ?? null);
    return result;
  }, [execute]);

  return {
    closingPeriod,
    closingPeriods,
    staffClosingPeriods,
    loading,
    error,
    clearError,
    fetchClosingPeriod,
    fetchForDepartment,
    fetchStaffClosingPeriods,
    initiatePeriodClose,
    calculatePeriod,
    exportPeriod,
  };
}
